import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { MerchantForm } from '../Forms';
import { Text1 } from '../../../styles';


const MerchantModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {props.title ? props.title : `${props.merchant.is_edit ? "Update" : "Create"} Merchant`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={700}
            title={false}
            visible={props.visible}
            onCancel={props.toggleMerchantModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <MerchantForm
                merchant={props.merchant}
                onSubmit={props.saveMerchant}
                loading={props.loading}
            />
        </EaseModal>
    )
};

MerchantModal.defaultProps = {
    merchant: {}
};

export { MerchantModal };